import {Component, forwardRef, Input} from "@angular/core";
import {MatFormField, MatPrefix} from "@angular/material/form-field";
import {MatOption, MatSelect} from "@angular/material/select";
import {MatIcon} from "@angular/material/icon";
import {ControlValueAccessor, NG_VALUE_ACCESSOR, ReactiveFormsModule} from "@angular/forms";
import {MatLabel} from "@angular/material/form-field";
import {MedicalServiceChoice} from "../../../model/medical/medical-service-choice.model";

@Component({
    selector : 'entry-selector',
    template : `
        <mat-form-field class="fuse-mat-dense flex-auto">
            <mat-label>{{ title }}</mat-label>
            <mat-select [value]="value" (selectionChange)="onChangeHandler($event.value)" (blur)="onTouched()">
                @for(val of this.options; track val) {
                    <mat-option value='{{ JSON.stringify(val) }}'>{{ val.name }}</mat-option>
                }
            </mat-select>
            <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:user'"></mat-icon>
        </mat-form-field>
    `,
    styles : `
        mat-form-field {
          width: 100%;
        }
    `,
    imports : [
        MatFormField,
        MatSelect,
        MatOption,
        MatIcon,
        ReactiveFormsModule,
        MatLabel,
        MatPrefix
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EntrySelectorComponent),
            multi: true
        }
    ]
})

export class EntrySelectorComponent implements ControlValueAccessor {
    // value: string | null = null;

    @Input()
    options: MedicalServiceChoice[];

    @Input()
    title: String;

    onChange = (_: any) => {};

    onTouched = () => {};

    writeValue(_: any): void {
        this.value = _;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    onChangeHandler(value: string): void {
        this.value = value;
        this.onChange(value);
    }

    protected readonly JSON = JSON;
    @Input() value!: string;
}